import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Contribution Portal Icon Component
 *
 * A document/form icon for the Contribution Portal feature.
 */
const WebFormIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 39.154 51.039">
      <defs>
        <clipPath id="clip-path-contribution">
          <rect
            id="Rectangle_1398"
            width="39.154"
            height="51.039"
            fill="#609690"
          />
        </clipPath>
      </defs>
      <g id="Contributions_icon" transform="translate(0 0)">
        <g
          id="Group_1878"
          transform="translate(0 -0.001)"
          clipPath="url(#clip-path-contribution)"
        >
          <path
            id="Path_2683"
            d="M34.915,51.039H4.239A4.246,4.246,0,0,1,0,46.8V4.239A4.245,4.245,0,0,1,4.239,0H34.915a4.242,4.242,0,0,1,4.239,4.239V46.8a4.243,4.243,0,0,1-4.239,4.243M4.239,2.028A2.216,2.216,0,0,0,2.028,4.239V46.8a2.217,2.217,0,0,0,2.211,2.215H34.915A2.214,2.214,0,0,0,37.125,46.8V4.239a2.213,2.213,0,0,0-2.211-2.211Z"
            transform="translate(0 0.002)"
            fill="#609690"
          />
          <path
            id="Path_2684"
            d="M37.378,6.452H.249V3.475A3.229,3.229,0,0,1,3.478.25H34.153a3.225,3.225,0,0,1,3.225,3.225Z"
            transform="translate(0.761 0.766)"
            fill="#b2d7d3"
          />
          <path
            id="Path_2685"
            d="M38.139,8.231H1.014A1.015,1.015,0,0,1,0,7.217V4.239A4.242,4.242,0,0,1,4.239,0H34.915a4.24,4.24,0,0,1,4.239,4.239V7.217a1.012,1.012,0,0,1-1.014,1.014M2.028,6.2h35.1V4.239a2.211,2.211,0,0,0-2.211-2.211H4.239A2.213,2.213,0,0,0,2.028,4.239Z"
            transform="translate(0 0.002)"
            fill="#609690"
          />
          <path
            id="Path_2686"
            d="M19.9,4.752H2.056a1.014,1.014,0,1,1,0-2.028H19.9a1.014,1.014,0,1,1,0,2.028"
            transform="translate(3.185 8.328)"
            fill="#609690"
          />
          <path
            id="Path_2687"
            d="M19.9,5.693H2.056a1.014,1.014,0,0,1,0-2.028H19.9a1.014,1.014,0,1,1,0,2.028"
            transform="translate(3.185 11.204)"
            fill="#609690"
          />
          <path
            id="Path_2688"
            d="M19.9,6.633H2.056a1.014,1.014,0,0,1,0-2.028H19.9a1.014,1.014,0,1,1,0,2.028"
            transform="translate(3.185 14.077)"
            fill="#609690"
          />
          <path
            id="Path_2689"
            d="M30.935,8.362H2.056a1.014,1.014,0,0,1,0-2.028H30.935a1.014,1.014,0,1,1,0,2.028"
            transform="translate(3.185 19.362)"
            fill="#609690"
          />
          <path
            id="Path_2690"
            d="M30.935,11.515H2.056a1.014,1.014,0,1,1,0-2.028H30.935a1.014,1.014,0,1,1,0,2.028"
            transform="translate(3.185 28.999)"
            fill="#609690"
          />
          <path
            id="Path_2691"
            d="M11.65,12.532H2.056a1.014,1.014,0,0,1,0-2.028H11.65a1.014,1.014,0,1,1,0,2.028"
            transform="translate(3.185 32.108)"
            fill="#609690"
          />
          <rect
            id="Rectangle_1394"
            width="7.014"
            height="7.63"
            transform="translate(27.106 12.068)"
            fill="#b2d7d3"
          />
          <path
            id="Path_2692"
            d="M14.46,12.383H7.446a1.015,1.015,0,0,1-1.014-1.014V3.738A1.012,1.012,0,0,1,7.446,2.724H14.46a1.012,1.012,0,0,1,1.014,1.014v7.63a1.015,1.015,0,0,1-1.014,1.014m-6-2.028h4.985v-5.6H8.46Z"
            transform="translate(19.66 8.328)"
            fill="#609690"
          />
          <rect
            id="Rectangle_1395"
            width="4.539"
            height="4.539"
            transform="translate(5.241 30.834)"
            fill="#b2d7d3"
          />
          <path
            id="Path_2693"
            d="M6.6,13.914H2.056A1.014,1.014,0,0,1,1.042,12.9V8.365A1.012,1.012,0,0,1,2.056,7.351H6.6A1.012,1.012,0,0,1,7.61,8.365V12.9A1.014,1.014,0,0,1,6.6,13.914M3.07,11.886H5.581V9.375H3.07Z"
            transform="translate(3.185 22.471)"
            fill="#609690"
          />
          <rect
            id="Rectangle_1396"
            width="4.539"
            height="4.539"
            transform="translate(17.411 30.834)"
            fill="#b2d7d3"
          />
          <path
            id="Path_2694"
            d="M9.6,13.914H5.056A1.014,1.014,0,0,1,4.042,12.9V8.365A1.012,1.012,0,0,1,5.056,7.351H9.6A1.012,1.012,0,0,1,10.61,8.365V12.9A1.015,1.015,0,0,1,9.6,13.914M6.07,11.886H8.581V9.375H6.07Z"
            transform="translate(12.354 22.471)"
            fill="#609690"
          />
          <rect
            id="Rectangle_1397"
            width="4.539"
            height="4.539"
            transform="translate(29.58 30.834)"
            fill="#b2d7d3"
          />
          <path
            id="Path_2695"
            d="M12.6,13.914H8.056A1.014,1.014,0,0,1,7.042,12.9V8.365A1.012,1.012,0,0,1,8.056,7.351H12.6A1.012,1.012,0,0,1,13.61,8.365V12.9A1.015,1.015,0,0,1,12.6,13.914M9.07,11.886h2.511V9.375H9.07Z"
            transform="translate(21.524 22.471)"
            fill="#609690"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default WebFormIcon;
